import React from 'react';

const LocationMap = () => {
    // Google Maps Embed URL for the specified address
    const mapUrl = "https://maps.google.com/maps?q=2%20Queen%20Anne's%20Place%2C%20Bush%20Hill%20Park%2C%20Enfield%2C%20EN1%202PX&t=&z=15&ie=UTF8&iwloc=&output=embed";

    return (
        <section style={{ backgroundColor: '#FFFDF7', padding: '60px 0' }}>
            <div className="container">
                <div className="text-center mb-5">
                    <h1 style={{ color: '#5A3411', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                        Find Us – Right in the Heart of Bush Hill Park!
                    </h1>
                    <p style={{ color: '#5A3411', opacity: 0.8, fontSize: '1.1rem', maxWidth: '1000px', margin: '0 auto' }}>
                        Our nursery is easy to find! Use the map below or follow the signs from nearby landmarks and stations.
                    </p>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div style={{
                            width: '100%',
                            height: '450px',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            boxShadow: '0 10px 30px rgba(90, 52, 17, 0.1)'
                        }}>
                            <iframe
                                title="Location Map"
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                marginWidth="0"
                                src={mapUrl}
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationMap;
